<template>
  <div class="container review-distance">
    <div class="row display-container">
      <div class="backgroundColor hidden-xs hidden-sm" :style="{ '--color' : non_repeat.image_background_color }">
        <img id="reviewImage-desktop" class="img lazy" :data-src="non_repeat.image">
      </div>
      <img id="reviewImage" class="img lazy" :data-src="non_repeat.image">
      <div id="reviewTitle" class="headline-review" :style="{ '--color' : non_repeat.headline_color}" v-html="non_repeat.headline"></div>
      <div class="hidden-xs hidden-sm mt-review">
        <div id="review-desktop" class="splide">
          <div class="splide__track">
            <ul class="splide__list">
              <li class="splide__slide" v-for="(repeat, index) in repeats" :key="'repeat-' + index">
                <div class="card">
                  <div class="card-body">
                    <div class="stars bottom-buffer">
                      <i class="glyphicon glyphicon-star"/>
                      <i class="glyphicon glyphicon-star"/>
                      <i class="glyphicon glyphicon-star"/>
                      <i class="glyphicon glyphicon-star"/>
                      <i class="glyphicon glyphicon-star"/>
                    </div>
                    <div id="reviewDescription" v-html="repeat['card_text']">
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                <path
                  d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                </path>
              </svg>
            </button>
            <div class="text-arrow">
              <span id="review-index-desktop" class="mr-review"></span> von <span id="review-length-desktop" class="ml-review"></span>
            </div>
            <button class="splide__arrow splide__arrow--next">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                <path
                  d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xs-12 visible-xs visible-sm no-padding">
      <div id="review-slider-mob" class="splide">
        <div class="splide__track">
          <ul class="splide__list">
            <li class="splide__slide" v-for="(repeat, index) in repeats" :key="'repeat-' + index">
              <div class="card">
                <div class="card-body">
                  <div class="stars bottom-buffer">
                    <i class="glyphicon glyphicon-star"/>
                    <i class="glyphicon glyphicon-star"/>
                    <i class="glyphicon glyphicon-star"/>
                    <i class="glyphicon glyphicon-star"/>
                    <i class="glyphicon glyphicon-star"/>
                  </div>
                  <p id="reviewDescriptionMob" v-html="repeat['card_text']">
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="splide__arrows display-arrow">
          <button class="splide__arrow splide__arrow--prev">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
              <path
                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
              </path>
            </svg>
          </button>
          <div class="text-arrow">
            <span id="review-index-mob"></span> von <span id="review-length-mob"></span>
          </div>
          <button class="splide__arrow splide__arrow--next">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
              <path
                d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
              </path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewSection",
  props: ['repeats', 'non_repeat'],
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";

.glyphicon-star {
  color: #d0b16b;
  font-size: 20px;
}

.review-distance {
  position: relative;
  margin-bottom: 31px;
  margin-top: 0;
}

.display-container {
  display: flex;
  justify-content: center;
}

.mt-review {
  margin-top: 200px;
}

.headline-review {
  position: absolute;
  margin-top: 7rem;
}
.mr-review {
  margin-right: 10px;
}
.ml-review {
  margin-left: 10px;
}
.splide__arrow {
  border: 1px solid $color-jungle-green;
  border-radius: 0;
  width: 54px;
  height: 54px;
}
.splide__arrows {
  color: $color-jungle-green;
}
.card-body{
  color:$color-jungle-green;
}

@media (min-width: $md-breakpoint-min) {
  .img {
    position: absolute;
    width: 946px;
    height: 400px;
    border-top-right-radius:12.5rem ;
  }
  .backgroundColor{
    position: absolute;
    background-color:var(--color);
    width: 946px;
    height: 400px;
  }

  .card-body {
    border: 1px solid white;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 2px 10px 8px 2px #dddddd;
    height: 300px;
    margin-bottom: 17px;
  }

  .splide__track {
    box-shadow: 0 0 0 0 #dddddd;
    padding-right: 20px !important;
    padding-left: 30px !important;
  }

  .splide__arrow--prev {
    left: 33em;
    margin-top: 208px;
    background: #FFFFFF;
  }

  .splide__arrow--next {
    left: 43.5em;
    margin-top: 208px;
    background: #FFFFFF;
  }

  .text-arrow {
    display: flex;
    margin-right: 10rem;
    justify-content: center;
    margin-top: 110px;
    font-size: 12px !important;
    font-family: "Open Sans";
    font-weight: bold;
  }
}

@media (max-width: $md-breakpoint-max) {
  .img {
    position: absolute;
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: left;
    border-top-right-radius:12.5rem ;
  }
  .backgroundColor{
    position: absolute;
    background-color:var(--color);
    width: 100%;
    height: 300px;
  }

  .card-body {
    border: 2px solid white;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 2px 5px 4px 0 #dddddd;
    height: 379px;
  }

  .card {
    margin-top: 100px;
    margin-left: 20px;
  }

  .splide__arrow {
    position: relative;
    top: 0;
    transform: none;
  }

  .splide__track {
    padding: 9px 15px !important;
  }

  .display-arrow {
    display: flex;
    justify-content: flex-start;
    margin-top: 35px;
    column-gap: 15px;
    padding-left: 35px;
  }
  .headline-review {
    margin: 0;
    padding-left: 35px;
    padding-right: 15px;
  }
  .splide__arrow--next {
    background: #FFFFFF;
    right: 0;
  }
  .splide__arrow--prev {
    background: #FFFFFF;
    left: 0;
  }
  .text-arrow {
    align-self: center;
    font-weight: bold;
    font-size: 12px !important;
  }
}
</style>
